// extracted by mini-css-extract-plugin
module.exports = {"outer":"NotFound_outer__1gwnN","info-panel":"NotFound_info-panel__59KmT"};